module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "lineups.05e927ca.png";